import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  Box,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import logo from '../assets/logo_back.png';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Features', path: '/features' },
  { label: 'Download', path: '/download' },
  { label: 'About Us', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

const NavBar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const drawerContent = (
    <Box sx={{ width: 250, textAlign: 'center', mt: 2 }}>
      {navLinks.map((item) => (
        <List key={item.label}>
          <ListItem disablePadding>
            <ListItemButton component={Link} to={item.path} onClick={() => setDrawerOpen(false)}>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        </List>
      ))}
    </Box>
  );

  return (
    <AppBar position="sticky" color="secondary" elevation={0} sx={{ py: 1 }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {/* LOGO */}
        <Box
          component={Link}
          to="/"
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="MindMapper AI"
            sx={{ height: 40, mr: 1 ,borderRadius: '50%'}}
          />
          {!isMobile && (
            <Typography variant="h6" sx={{ color: '#fff' }}>
              MindMapper AI
            </Typography>
          )}
        </Box>

        {/* DESKTOP NAV */}
        {!isMobile && (
          <Box>
            {navLinks.map((item, index) => (
              <motion.div
                key={item.label}
                whileHover={{ scale: 1.1, x: 5 }}
                transition={{ type: 'spring', stiffness: 300 }}
                style={{ display: 'inline-block', marginLeft: theme.spacing(3) }}
              >
                <Button
                  component={Link}
                  to={item.path}
                  sx={{ color: '#fff', fontWeight: 500 }}
                >
                  {item.label}
                </Button>
              </motion.div>
            ))}
          </Box>
        )}

        {/* MOBILE NAV ICON */}
        {isMobile && (
          <IconButton color="inherit" onClick={handleDrawerToggle}>
            <MenuIcon />
          </IconButton>
        )}
      </Toolbar>

      {/* DRAWER */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        sx={{ display: { md: 'none' } }}
      >
        {drawerContent}
      </Drawer>
    </AppBar>
  );
};

export default NavBar;
